@if (component) {
@if(component.services.length <= [1,3,4,4][client.sizeId])
   {
   <div
   class="wrap flex flex-justify-center">
    @for (service of component.services; track $index; let first = $first; let last = $last) {
    <div [ngClass]="component.services.length < 4 ? 'c-4-set-x c-4-set-l' : 'c-3-set-x c-3-set-l'"
         class=" c-4-set-m c-12-set-s m-b-0">
        <ng-container *ngTemplateOutlet="serviceTpl; context: { $implicit: service }"></ng-container>
    </div>
    }
    </div>
    } @else {
    <carousel class="default-swiper wrap"
              [loop]="true"
              [pagination]="{clickable: true}"
              [slidesPerView]="'auto'"
              [navigation]="false"
              [scrollbar]="false"
              [style.--pc-slides-ceil]="pcSlidesCeil"
              [style.--pc-slides]="pcSlides">
        @for (service of component.services; track $index) {
        <ng-template swiperSlide>
            <ng-container *ngTemplateOutlet="serviceTpl; context: { $implicit: service }"></ng-container>
        </ng-template>
        }
    </carousel>
    }
    }
    <ng-template #serviceTpl
                 let-service>
        <div class="center flex-column flex-middle flex-justify-start height-100">
            <i style="font-size: 52px"
               [ngClass]="service.icon"></i>
            <h3 class="h3 m-t-1 m-b-2 col-1"
                *iCms="'title' of service"></h3>
            <p class="p2 col-1"
               *iCms="'description' of service; skipEmpty: true"></p>
            @if(service?.cta_copy && service?.cta_link){
            @if(service.link_button){
            <a class="m-t-2 link"
               [routerLink]="service.cta_link">
                <span class="s2"
                      *iCms="'cta_copy' of service"></span>
            </a>
            } @else {
            <href [link]="service.cta_link">
                <button [buttonStyle]="service?.button_style"
                        class="m-t-2">
                    <span *iCms="'cta_copy' of service"></span>
                </button>
            </href>
            }
            }
        </div>
    </ng-template>